import React from 'react';

function Time(props) {

    const {
        time, // 时:分, 00:00
        setTime
    } = props;

    return (
        <div className="time-picker-container">
            <input
                type="time"
               className="custom-time-input"
               value={time}
               onChange={(event)=>{setTime(event.target.value)}}
            />
        </div>
    );
}

export default Time;